import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mecanizado',
  templateUrl: './mecanizado.component.html',
  styleUrls: ['./mecanizado.component.css']
})
export class MecanizadoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
